/*
  Mixin used to manage user rights
*/
import { mapState } from 'vuex';
import { RAISON_EXPERT_ROLE, RAISON_PARAMETERIZER_ROLE } from '@/config/constants';

export default  {
  computed: {
    ...mapState(['user',]),
    isUserExpert () {
      if (this.user && this.user['cognito:groups']) {
        return this.user['cognito:groups'].indexOf(RAISON_EXPERT_ROLE) > -1;
      }
      return false;
    },

    isUserParameterizer () {
      if (this.user && this.user['cognito:groups']) {
        return this.user['cognito:groups'].indexOf(RAISON_PARAMETERIZER_ROLE) > -1;
      }
      return false;
    },
  },
};
